import { ApiError, UnauthorizedError } from './api';

/**
 * Maps a write-mutation error to a user-facing message. The
 * server is the trust boundary, so even with the owner-only UI a 403/401/422 can
 * still come back; we surface a clear, PII-free message inline on the form.
 */
export function describeSubmitError(error: unknown): string {
  if (error instanceof UnauthorizedError) {
    return '로그인이 필요해요. 다시 로그인한 뒤 시도해 주세요.';
  }
  if (error instanceof ApiError) {
    if (error.status === 403) return '이 작업을 수행할 권한이 없어요.';
    if (error.status === 422) return '입력값을 확인해 주세요. 필수 항목과 길이를 다시 확인해 주세요.';
    if (error.status === 404) return '대상을 찾을 수 없어요.';
  }
  return '저장에 실패했어요. 잠시 후 다시 시도해 주세요.';
}
